
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformRotate as ObiTransformRotateElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transform-rotate.js';
 
 
 

 
 export const ObiTransformRotate = createComponent({
   react: React,
   tagName: 'obi-transform-rotate',
   elementClass: ObiTransformRotateElement,
   events: {
     
   }
  });
 
 